import { gql } from "@apollo/client";

export const getPublishedCustomerPortal = gql`
  query getPublishedCustomerPortal($company_id: String) {
    getPublishedCustomerPortal(company_id: $company_id) {
      id
      title
      logo_url
      favicon_url
      primary_font
      primary_color
      background_image
      phone_number
      email_address
      redirect_url
      domain
      company_id
      company {
        name
      }
    }
  }
`;

